import Swiper, { Pagination, Navigation, A11y } from 'swiper';

import './_common.js';
import '../css/expert-zone.scss';

function setupTestimonialsSlider()
{
    new Swiper('.expert-zone-testimonials-slider', {
        speed: 500,
        modules: [Pagination, Navigation, A11y],

        navigation: {
            nextEl: '.expert-zone-testimonials-slider-button-next',
            prevEl: '.expert-zone-testimonials-slider-button-prev',
        },
        pagination: {
            el: '.expert-zone-testimonials-slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        a11y: {
            notificationClass: 'sr-only',
        },

        watchOverflow: true,

        slidesPerColumnFill: 'row',
        centerInsufficientSlides: true,

        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
            576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },

        on: {
            init: () => {
                document.querySelector('.expert-zone-testimonials').classList.remove('invisible');
            },
        },
    });

    document.querySelectorAll('.expert-zone-testimonials-slider-button').forEach(element => {
        element.addEventListener('click', () => { element.blur(); });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    setupTestimonialsSlider();
});
